import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { firestore } from "../../../firebase";
import SectionContainer from "../../../components/landing/section-container";
import { MuiTelInput } from "mui-tel-input";
import { isValidPhoneNumber } from "libphonenumber-js";

function SubscribePage() {
  const [number, setNumber] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  async function handleSave() {
    setIsSaving(true);
    try {
      await addDoc(collection(firestore, "phoneNumbers"), {
        number: number,
      });
      setNumber("");
      setSuccessful(true);
      setError("");
    } catch {
      setError("No se pudo agregar el número telefónico. Inténtalo de nuevo.");
    }
    setIsSaving(false);
  }

  const handleChange = (newValue: string) => {
    setNumber(newValue);
    const valid = isValidPhoneNumber(newValue);
    setIsValid(valid);
  };

  return !successful ? (
    <SectionContainer
      id="Subscribe"
      title="Suscríbase a nuestro boletín informativo"
    >
      <Box
        component="form"
        sx={{ "& > :not(style)": { m: 1 } }}
        noValidate
        autoComplete="off"
      >
        <Typography>
          ¡Sea el primero en estar al tanto de habitaciones disponibles!
        </Typography>
        <MuiTelInput
          value={number}
          defaultCountry={"CR"}
          onChange={handleChange}
        />
        <Stack spacing={2} direction="row">
          <Button
            onClick={(e) => {
              handleSave();
            }}
            variant="outlined"
            color="primary"
            disabled={!isValid || isSaving}
          >
            Suscribirme
          </Button>
        </Stack>
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Box>
    </SectionContainer>
  ) : (
    <SectionContainer id="successful-message">
      <Typography marginTop="10px" display="block">
        Gracias por suscribirse, le estaremos notificando cuándo tengamos
        habitaciones disponibles.
      </Typography>
    </SectionContainer>
  );
}

export default SubscribePage;
